<template>
	<label class="portal-search-field">
		<portal-icon name="search" :size="18" aria-hidden="true"></portal-icon>
		<input
			type="search"
			:value="value || ''"
			:placeholder="placeholder"
			:aria-label="label"
			@input="$emit('input', $event.target.value)"
			@change="$emit('change', $event.target.value)"
		/>
		<button
			v-if="value"
			type="button"
			class="clear-search"
			:aria-label="clearLabel"
			@click="clear"
		>
			<portal-icon name="x" :size="16"></portal-icon>
		</button>
	</label>
</template>

<script>
	export default {
		name: 'PortalSearchField',

		props: {
			value: { type: String, required: false, default: '' },
			label: { type: String, required: true },
			placeholder: { type: String, required: true },
			clearLabel: { type: String, required: true },
		},

		methods: {
			clear() {
				this.$emit('input', '');
				this.$emit('change', '');
			},
		},
	};
</script>

<style scoped lang="scss">
	.portal-search-field {
		min-width: min(260px, 100%);
		height: 42px;
		flex: 1 1 280px;
		display: flex;
		align-items: center;
		gap: 9px;
		padding: 0 11px;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-field-radius, 12px);
		background: var(--brand-field-fill, var(--portal-canvas));
		color: var(--brand-surfaceFieldPlaceholder, var(--portal-muted));
		transition: border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
	}

	.portal-search-field:focus-within {
		border-color: var(--v-primary-base);
		background: var(--brand-field-fill, var(--portal-surface));
		box-shadow: 0 0 0 3px color-mix(in srgb, var(--v-primary-base) 12%, transparent);
	}

	input {
		min-width: 0;
		flex: 1;
		border: 0;
		outline: 0;
		background: transparent;
		color: var(--brand-surfaceFieldAnswer, var(--portal-text));
		font: inherit;
		font-size: 14px;
	}

	input::placeholder {
		color: var(--brand-surfaceFieldPlaceholder, var(--portal-muted));
		opacity: 0.82;
	}

	input::-webkit-search-cancel-button {
		display: none;
	}

	.clear-search {
		width: 26px;
		height: 26px;
		display: grid;
		place-items: center;
		padding: 0;
		border: 0;
		border-radius: var(--brand-button-radius, 8px);
		background: transparent;
		color: var(--brand-surfaceFieldPlaceholder, var(--portal-muted));
		cursor: pointer;
	}

	.clear-search:hover {
		background: var(--v-gray_20-base);
		color: var(--portal-text);
	}

	@media (prefers-reduced-motion: reduce) {
		.portal-search-field {
			transition: none;
		}
	}
</style>
